module.exports = __webpack_public_path__ + "static/Carpool-redesign-find-cc8b8d30ae1ac48c13ea223fbcc241bf.gif";